// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Clock = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <circle fill={fill || 'none'} cx='23.2' cy='23.2' r='22.7' />
      <line fill='none' x1='44.6' y1='23.6' x2='41.5' y2='23.6' />
      <line fill='none' x1='5.2' y1='23.6' x2='2' y2='23.6' />
      <line fill='none' x1='23.3' y1='41.8' x2='23.3' y2='45' />
      <line fill='none' x1='41.8' y1='13' x2='39.1' y2='14.5' />
      <line fill='none' x1='7.6' y1='32.7' x2='4.9' y2='34.3' />
      <line fill='none' x1='12.7' y1='5.2' x2='14.2' y2='7.9' />
      <line fill='none' x1='32.4' y1='39.4' x2='34' y2='42.1' />
      <line fill='none' x1='41.8' y1='34.3' x2='39.1' y2='32.7' />
      <line fill='none' x1='7.6' y1='14.5' x2='4.9' y2='13' />
      <line fill='none' x1='34' y1='5.2' x2='32.4' y2='7.9' />
      <line fill='none' x1='14.2' y1='39.4' x2='12.7' y2='42.1' />
      <polyline fill='none' points='35.1 11.9 23.4 23.9 11 20' />
      <line fill='none' x1='23.3' y1='1.9' x2='23.3' y2='7.9' />
      <line fill='none' x1='23.3' y1='38.6' x2='23.3' y2='44.6' />
      <line fill='none' x1='2' y1='23.2' x2='8' y2='23.2' />
      <line fill='none' x1='38.7' y1='23.2' x2='44.6' y2='23.2' />
    </svg>
  );
};
